import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { viewSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListTableViewFilter";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

viewSelectStyles.wrapper = mergeToNew(viewSelectStyles.wrapper, {
    css: css`
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding-top: 10px;
                    `,
                    null,
                    null,
                    css`
                        padding-top: 0;
                    `,
                ],
                "min",
            )};
    `,
});

viewSelectStyles.filterIcon = mergeToNew(viewSelectStyles.filterIcon, {
    size: 21,
});

viewSelectStyles.filterClickable = mergeToNew(viewSelectStyles.filterClickable, {
    css: css`
        margin-right: 20px;
        svg {
            stroke: ${getColor("primary")};
        }
    `,
});

viewSelectStyles.tagIcon = mergeToNew(viewSelectStyles.tagIcon, {
    size: 21,
});

viewSelectStyles.tagClickable = mergeToNew(viewSelectStyles.tagClickable, {
    css: css`
        margin-right: 20px;
        display: none;
        svg {
            stroke: ${getColor("primary")};
        }
    `,
});
